import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getLeaderboardWithScoresKey } from '../../utils/keys';
export const useLeaderboardWithScores = (options) => {
    const { args, fields = 'default', useQueryOptions } = options;
    const { client } = useTribeClient();
    const leaderboardWithScoresKey = getLeaderboardWithScoresKey(args);
    return useQuery(leaderboardWithScoresKey, () => client.report.getLeaderboardWithScores(args, fields), useQueryOptions);
};
//# sourceMappingURL=useLeaderboardWithScores.js.map